<template>
  <PopupModal :open="open" class="sm:max-w-3xl sm:w-full h-[540px]">
    <template #body>
      <div class="flex flex-row text-left">
        <div class="flex flex-col items-start">
          <div v-if="appointment.articleImage">
            <img
              :src="appointment.articleImage"
              alt="appointment teaser image"
              class="w-full object-cover rounded-lg"
            />
          </div>
          <p class="mt-1 text-sm">{{ t("appointment.info.text") }}</p>
          <h3 class="text-lg">
            {{ helperFunctions.limitString(appointment.appointmentName) }}
          </h3>
          <div v-if="appointment.startAt" class="flex flex-row mt-6">
            <StartIcon class="bg-bkk-25 rounded-full" />
            <p class="ml-2">
              {{
                dateManager.formatDateGermanFormatWithTime(
                  appointment.startAt
                ) +
                " " +
                t("appointment.oclock")
              }}
            </p>
          </div>
          <div v-if="appointment.endAt" class="flex flex-row mt-2">
            <EndIcon class="bg-bkk-25 rounded-full" />
            <p class="ml-2">
              {{
                dateManager.formatDateGermanFormatWithTime(appointment.endAt) +
                " " +
                t("appointment.oclock")
              }}
            </p>
          </div>
          <div
            v-if="appointment.longDescription"
            class="mt-6 text-left styled-link"
            @click="(e) => e.preventDefault()"
            v-html="appointment.longDescription"
          ></div>
        </div>
      </div>
    </template>
    <template #footer>
      <div class="flex flex-col md:flex-row mt-4 gap-4">
        <BaseButton
          class="w-full md:w-1/2"
          variant="primary"
          @click="downloadAppointment"
        >
          {{ t("appointment.add.button.caption") }}
        </BaseButton>
        <BaseButton
          class="w-full md:w-1/2"
          variant="outline"
          @click="$emit('close')"
          >{{ t("appointment.cancel.button.caption") }}</BaseButton
        >
      </div>
    </template>
  </PopupModal>
</template>

<script setup lang="ts">
import BaseButton from "../layout/button/BaseButton.vue";
import { useI18n } from "vue-i18n";
import PopupModal from "~/components/v2/layout/PopupModal.vue";
import { AppointmentDto } from "../../../dto/appointment.dto";
import EndIcon from "~/components/v2/icon/EndIcon.vue";
import { getCurrentInstance } from "vue";
import StartIcon from "~/components/v2/icon/StartIcon.vue";
import { downloadArticleAppointment } from "~/api/articleAppointment";

const { t } = useI18n();

const props = defineProps<{
  open: boolean;
  appointment: AppointmentDto;
}>();

const emits = defineEmits(["close"]);

const { appContext } = getCurrentInstance()!;
const helperFunctions = appContext.config.globalProperties.$helperFunctions;
const dateManager = appContext.config.globalProperties.$dateManager;

async function downloadAppointment() {
  const res = await downloadArticleAppointment(props.appointment.appointmentId);

  if (res) {
    helperFunctions.downloadICSFile(
      res.data,
      props.appointment.appointmentName
    );
  }
}
</script>

<style>
.styled-link a {
  text-decoration: underline;
}
</style>
